module.exports = __webpack_public_path__ + "media/application/images/icons/twitter-4871c9c931a919c291fea5e7213b1800.svg";